import React from "react";
import { cn } from "./cn";

const STYLE = {
  info: "bg-sky-50 border-sky-200 text-sky-900",
  success: "bg-emerald-50 border-emerald-200 text-emerald-900",
  warning: "bg-amber-50 border-amber-200 text-amber-900",
  error: "bg-red-50 border-red-200 text-red-900",
};

export default function Toast({ kind = "info", children, className, role = "status" }) {
  return (
    <div
      role={role}
      className={cn(
        "rounded-2xl border px-4 py-3 text-sm font-medium shadow-sm",
        STYLE[kind] ?? STYLE.info,
        className
      )}
    >
      {children}
    </div>
  );
}
